import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";

export class LayoutContent extends BaseComponent<ILayoutContentProps, ILayoutContentState>
{
    public render(): JSX.Element
    {
        return (
            <>
                {this.props.children}
            </>
        );
    }
}

export interface ILayoutContentProps
{
    children: ReactNode;
}

export interface ILayoutContentState { }
